'use client';

import { useBreakpointValue } from '@chakra-ui/react';

/** Defaults to mobile on SSR (primary audience); hydrates to lg on desktop. */
export function useIsDesktop() {
  return useBreakpointValue({ base: false, lg: true }) ?? false;
}

/** Defaults to mobile on SSR. */
export function useIsMobile() {
  return useBreakpointValue({ base: true, lg: false }) ?? true;
}

/** md breakpoint variant; defaults to mobile on SSR. */
export function useIsMobileMd() {
  return useBreakpointValue({ base: true, md: false }) ?? true;
}

/** lg–xl range; defaults to false on SSR (mobile-first). */
export function useIsLaptop() {
  return useBreakpointValue({ lg: true, xl: false }) ?? false;
}
